import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyle {
  closeButton: FelaCSS;
  textWrapper: FelaCSS;
  headline: FelaCSS;
  bottomLine: FelaCSS;
  stars: FelaCSS;
  rating: FelaCSS;
  buttonWrapper: FelaCSS;
  buttonStyleWrapper: FelaCSS;
}

export const styles: IStyle = {
  closeButton: {
    padding: 1,
    border: 0,
    background: 'none',
    textAlign: 'left',
  },
  textWrapper: {
    flex: 1,
  },
  headline: {
    fontDefaultSemiBold: 14,
    color: colors.white,
  },
  bottomLine: {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing[1],
  },
  stars: {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing[1],
  },
  rating: {
    fontDefault: 11,
    color: colors.white,
  },
  buttonWrapper: {
    flexGrow: 0,
    width: 'fit-content',
  },
  buttonStyleWrapper: {
    hover: {
      backgroundColor: colors.space04,
    },
    active: {
      backgroundColor: colors.space08,
    },
  },
};
